import _extends from "@babel/runtime/helpers/extends";
import { usePress } from "@react-aria/interactions";
import { useMenuTrigger } from "@react-aria/menu";
import { Overlay, usePopover } from "@react-aria/overlays";
import { mergeProps } from "@react-aria/utils";
import { useMenuTriggerState } from "@react-stately/menu";
import React, { useLayoutEffect, useRef, useState } from "react";
import styled from "styled-components";
import { FadeInAnimation, FadeOutAnimation } from "../../shared/animations/FadeAnimation";
import { MenuRoot } from "./MenuRoot";

/** Props passed to the `trigger` render function of the dropdown. */

/** A render prop function that renders the trigger element for the dropdown. */

/** Props for the MenuDropdown component. */

export function MenuDropdown(_ref) {
  let {
    trigger,
    triggerType = "press",
    ...otherProps
  } = _ref;
  const triggerRef = useRef(null);
  const popoverRef = useRef(null);
  const menuTriggerState = useMenuTriggerState({
    ...otherProps,
    trigger: triggerType
  });
  const {
    menuTriggerProps,
    menuProps
  } = useMenuTrigger({
    ...otherProps,
    trigger: triggerType
  }, menuTriggerState, triggerRef);
  const {
    pressProps: triggerProps
  } = usePress(menuTriggerProps);
  const {
    popoverProps
  } = usePopover({
    containerPadding: 24,
    offset: 8,
    placement: "bottom start",
    ...otherProps,
    popoverRef,
    triggerRef
  }, menuTriggerState);
  const [isExiting, setIsExiting] = useState(false);
  useLayoutEffect(() => {
    setIsExiting(!menuTriggerState.isOpen);
  }, [menuTriggerState.isOpen]);
  const handleAnimationEnd = () => {
    setIsExiting(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, trigger({
    triggerProps: {
      ...triggerProps,
      ref: triggerRef
    }
  }), (menuTriggerState.isOpen || isExiting) && /*#__PURE__*/React.createElement(Overlay, {
    isExiting: isExiting
  }, /*#__PURE__*/React.createElement(StyledMenuRoot, _extends({}, mergeProps(popoverProps, menuProps, otherProps), {
    isExiting: isExiting,
    onAnimationEnd: handleAnimationEnd,
    ref: popoverRef
  }))));
}
const StyledMenuRoot = styled(MenuRoot).withConfig({
  displayName: "MenuDropdown__StyledMenuRoot"
})(["animation:", " 0.1s ease-out forwards;overflow:auto;"], _ref2 => {
  let {
    isExiting
  } = _ref2;
  return isExiting ? FadeOutAnimation : FadeInAnimation;
});
//# sourceMappingURL=MenuDropdown.js.map